import { render, staticRenderFns } from "./ModalEditRecommendedPrice.vue?vue&type=template&id=79ee2ec3"
import script from "./ModalEditRecommendedPrice.vue?vue&type=script&lang=js"
export * from "./ModalEditRecommendedPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports